module.exports = __webpack_public_path__ + "img/hudson.bd1181c.png";